import React, { useEffect } from 'react';
const AnswerOptionsSelect = ({
  AnswerArray, ArrayIndex,
  Data, DataValue, DataType,
  option, DataValueText,optionvalue
}) => {
  return (
    <div className={
      AnswerArray[ArrayIndex].correct_answer == option ?
        "correct-option-result" :
        Data == option ?
          "wrong-option-result"
          : ""
    }>
      <div className="answer-option-style"
        style={{ display: 'flex' }}
      >
        {optionvalue}
        {/* {Data == option &&
          <i class="fa fa-check-circle-o"></i>
          // :<i class="fa fa-circle-o"></i>
        } */}
        <div className={
          Data == option ?
            "active-option2"
            : "passive-option2"
        }>
          {/* {DataType == "text" &&
            `${DataValue}`
          } */}
          {(DataType == "text" || DataType == "underline") &&
            <span  >
              <div className="answer-text" dangerouslySetInnerHTML={{ __html: DataValue.replace(DataValueText, `<u>${DataValueText}</u>`) }}></div>
              {/* {DataValue}  */}
            </span>
          }
          {DataType == "image" &&
            <img
              src={DataValue}
              style={{
                height: "100px",
                objectFit: 'contain',
                border: "0.5px solid #000"
              }}
            />
          }
          {DataType == "audio" &&
            <audio
              controls
              src={`${DataValue}`}
            >
              {/* <source src={`${ImageUrl}`} type="audio/ogg" /> */}
              {/* <source src={`${DataValue}`} type="audio/mpeg" />
            Your browser does not support the audio element. */}
            </audio>
          }
          {DataType == "video" &&
            <video width="400" controls>
              <source src={`${DataValue}`} type="video/mp4"
                style={{ height: "150px", width: "200px" }}
              />
            </video>
          }
          {DataType == "youtube" &&
            <iframe width="400" height="150" src={`https://www.youtube.com/embed/${DataValue}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          }
        </div>
      </div>
    </div>
  )
}
export default function SecondResultScreenComponent(props) {
  const {
    oneQuestionData,
    AnswerArray, ArrayIndex,
    setQuestionsSolved, QuestionsSolved
  } = props;
  const [question, setQuestion] = React.useState(oneQuestionData.question)

  const [AnswerSelected, setAnswerSelected] = React.useState("")
  useEffect(() => {
    if (AnswerArray[ArrayIndex].answerChoosen !== "") {
      setAnswerSelected(AnswerArray[ArrayIndex].answerChoosen)
    }
  }, [])


  return (
    <div>
      <div className="row" style={{ border: "1px solid #999", width: "100%", marginLeft: 10, overflow: "hidden" }}>
        <div className="col-md-8">
          <div style={{ margin: "3px", padding: "10px", }}>
            <div >
              <h3 style={{ fontSize: "22px", fontWeight: "bold" }}>
                {ArrayIndex + 1}. {oneQuestionData.question}
                {/* {JSON.stringify(oneQuestionData)} */}
                {/* {oneQuestionData.question_number}. {oneQuestionData.question} */}
              </h3>
              <h3 className="question-font" style={{ fontWeight: "bold", margin: 0, paddingBottom: 0 }}>
                {/* {oneQuestionData.question_number}. */}
                <span style={{ fontSize: "18px", fontWeight: "normal" }}>{oneQuestionData.question_text}</span>
              </h3>
            </div>
            <div className="question-description">
              {oneQuestionData.question_description == "" &&
                <div style={{
                  fontSize: "20px",
                  // padding: "0 0 15px"
                }}>
                  <div className="question-font" dangerouslySetInnerHTML={{ __html: oneQuestionData.question_description.replaceAll('\n', '<br/>') }}></div>
                </div>
              }
              {oneQuestionData.question_image !== "" &&
                <>
                  <div className="center"
                    onClick={() => {
                    }}
                  >
                    <img className="question-image"
                      src={oneQuestionData.question_image}
                    />
                  </div>
                </>
              }
              {oneQuestionData.question_audio.includes("https:") &&
                <div>

                  <audio controls >

                    <source src={`${oneQuestionData.question_audio}`} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              }
            </div>

            {oneQuestionData.question_box_text !== "" &&
              <div className="question-description">
                <div style={{
                  border: "0.5px solid #000",
                  padding: "15px ",
                  justifyContent: 'center',
                  display: "flex",
                  borderRadius: "20px"
                }}>
                  <div className="question-font" dangerouslySetInnerHTML={{ __html: oneQuestionData.question_box_text.replaceAll('\n', '<br/>') }}></div>
                </div>
              </div>
            }

          </div>
        </div>
        <div className="col-md-4">
          <div style={{ border: "1px solid #999" }}>
            <AnswerOptionsSelect
              AnswerArray={AnswerArray} ArrayIndex={ArrayIndex}
              DataType={oneQuestionData.answer_media_type}
              Data={AnswerSelected}
              DataValue={oneQuestionData.option_1}
              DataValueText={oneQuestionData.option_1_text}
              option={"option 1"}
              optionvalue={"①"}
            />
          
            <AnswerOptionsSelect
              AnswerArray={AnswerArray} ArrayIndex={ArrayIndex}
              DataType={oneQuestionData.answer_media_type}
              Data={AnswerSelected}
              DataValue={oneQuestionData.option_2}
              option={"option 2"}
              DataValueText={oneQuestionData.option_1_text}
              optionvalue={"②"}
            />
            <AnswerOptionsSelect
              AnswerArray={AnswerArray} ArrayIndex={ArrayIndex}
              DataType={oneQuestionData.answer_media_type}
              Data={AnswerSelected}
              DataValue={oneQuestionData.option_3}
              DataValueText={oneQuestionData.option_3_text}
              option={"option 3"}
              optionvalue={"③"}
            />
            <AnswerOptionsSelect
              AnswerArray={AnswerArray} ArrayIndex={ArrayIndex}
              DataType={oneQuestionData.answer_media_type}
              Data={AnswerSelected}
              DataValue={oneQuestionData.option_4}
              DataValueText={oneQuestionData.option_4_text}
              option={"option 4"}
              optionvalue={"④"}
            />
          </div>
        </div>
      </div>
      <div className="center row">
        <h3 className="col-5 ">
          {AnswerArray[ArrayIndex].solved == 0 ?
            <div className="wrong-option-result-2 ">
              Question Unsolved
            </div> :
            <div>
              {AnswerArray[ArrayIndex].correct_answer == AnswerArray[ArrayIndex].answerChoosen ?
                <div className="correct-option-result-2 ">
                  Correct Answer
                </div>
                :
                <div className="wrong-option-result-2 ">
                  Wrong Answer
                </div>
              }
            </div>
          }

        </h3>
      </div>
    </div>
  )
}
